<template>

  <div class="shared-projects">
    <!-- [ Header ] start -->
    <!--<Header @setSharedTask="setSharedTask" :open="open" @openDialog="openDialog" @showMenu="showMenu" @hideMenu="hideMenu" />-->
    <!-- [ Header ] end -->
    <div class="content">
          <!--{{activeInfoTab}}-->
      <!-- [ Menu ] start -->
      <!--<Menu :open="open" @setCompany="refreshBlock" @companyName="companyName"/>-->
      <!-- [ Menu ] end -->

      <div class="wrap">
        <div class="left-side">
          <!--{{rowData}}<br>-->
          <!--{{selectedTaskForInfo}}<br>-->
          <!--{{activeInfoTab}}-->
          <!--{{valueProject}}-->
          <!--{{selectedRow}}<br>++++++++++++++++++++<br>-->
          <!--{{rowData[0]}}-->
            <!--{{companyLayout.companyUserId}}-->
          <!-- [ Tree ] start -->

          <div class="nav-tree">
            <el-select no-data-text="no date" v-model="valueProject" placeholder="Select Project" size="mini">
              <el-option
                      v-for="item in project"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      @click.native="setProjectRowData(item.id, 'first')">
              </el-option>
            </el-select>
            <!--{{project}}-->
              <!--{{activeInfoTab}}-->
            <el-button v-if="companyLayout" :disabled="disabledBtn || !companyLayout.permission.assignTeam" class="nav-tree__item" size="mini" @click="assignTeamOpen" type="menu" icon="el-icon-plus">Assign Team</el-button>
          </div>
            <!--{{activeTab}}-->
            <ag-grid-vue style="width: 100%; height: 96%;" class="ag-theme-balham" id="myGrid"
                         :gridOptions="gridOptions"
                         @grid-ready="onGridReady"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :getRowHeight="getRowHeight"
                         :rowDragManaged="false"
                         :suppressRowHoverHighlight="true"
                         :getContextMenuItems="getContextMenuItems"
                         :animateRows="true"
                         :rowData="rowData"
                         :rowSelection="rowSelection"
                         @selection-changed="onSelectionChanged">
            </ag-grid-vue>
        </div>
        <!-- [ Tree ] end -->

        <!-- [ Tree info ] start -->
        <div class="wrap__info">
          <el-tabs type="border-card" v-model="activeTab" @tab-click="handleClick">
            <el-tab-pane :disabled="disabledBtn" label="Info" name="first">
              <InfoTab v-model="activeInfoTab"
                       v-if="!disabledBtn"
                       :activeProjectId="activeProjectId"
                       :selectedProjectForInfo="false"
                       :selectedTaskForInfo="selectedTaskForInfo"
                       :isProject="isProject"
                       :selectedRow="selectedRow"
                       :taskInfo="taskInfo"
                       @submit="getTaskInfo"
              />
            </el-tab-pane>
            <el-tab-pane :disabled="disabledBtn" label="Files" name="second">
              <taskFilesTabNew
                      v-if="!disabledBtn"
                      :selectedRow="selectedRow" />
            </el-tab-pane>
            <el-tab-pane :disabled="disabledBtn" label="Progress" name="third">
              <projProgressTab
                      v-if="!disabledBtn"
                      :selectedRow="selectedRow"
                      :selectedTaskForInfo="selectedTaskForInfo"
                      :selectedRowId="selectedRow.id"
                      :activeProjectId="activeProjectId"
                      @submit="setProjectRowData" />
            </el-tab-pane>
            <el-tab-pane :disabled="disabledBtn" label="Task Comments" name="four">
              <taskCommentsTab v-if="!disabledBtn" :selectedRow="selectedRow" :activeProjectId="activeProjectId"/>
            </el-tab-pane>
            <el-tab-pane :disabled="disabledBtn" label="Task Messages" name="seven">
              <!-- <div class="text">Task Messages</div> -->
              <MessagesTask v-if="!disabledBtn" type="task" :selectedRow="selectedRow" :activeProjectId="activeProjectId"/>
            </el-tab-pane>
            <el-tab-pane :disabled="disabledBtn" label="Meetings" name="eight">
              <projectTaskMeetings :selectedRow="selectedRow"  />
            </el-tab-pane>
            <el-tab-pane :disabled="disabledBtn" label="Documents" name="fourteen" v-if="selectedRow.sharedStatus === 'sharedTeam'">
              <DocumentsTask ref="docs" :selectedRow="selectedRow" :bookmarkList="[]"/>
            </el-tab-pane>
            <el-tab-pane :disabled="disabledBtn" label="accountTHINK" name="accountTHINK">
              <accountTHINKTab
                      v-model="activeAccountTHINKTab"
                      :isProject="false"
                      :selectedRow="selectedRow"
                      ref="accountTHINKTab"/>
            </el-tab-pane>
            <!--<el-tab-pane label="SOP" name="nine">-->
            <!--<div class="text">Current Service Under Development</div>-->
            <!--</el-tab-pane>-->
            <!--<el-tab-pane label="Policy" name="ten">-->
            <!--<div class="text">Current Service Under Development</div>-->
            <!--</el-tab-pane>-->
            <!--<el-tab-pane label="OH&S" name="eleven">-->
            <!--<div class="text">Current Service Under Development</div>-->
            <!--</el-tab-pane>-->
          </el-tabs>
        </div>
        <sweet-modal blocking ref="assignTeamModal" v-on:close="assignTeamClose">
          <el-form :model="assignTeam" :rules="rules" status-icon ref="assignTeam" label-width="0" class="demo-ruleForm" label-position="top">
            <h1>Assign Team</h1>
            <div class="flex two-columns">
              <!--<div>-->
                <!--<el-form-item prop="companyId" label="Companies" label-width="90px">-->
                  <!--<el-select v-model="assignTeam.companyId" placeholder="Companies">-->
                    <!--<el-option-->
                            <!--v-for="assign in assignTeam.companies"-->
                            <!--:key="assign.id"-->
                            <!--:label="assign.name"-->
                            <!--:value="assign.id"-->
                            <!--@click.native="selectCompany(assign.id)"></el-option>-->
                  <!--</el-select>-->
                <!--</el-form-item>-->
              <!--</div>-->
              <div>
                <el-form-item prop="teamIdList" label="Assign Team" label-width="90px">
                  <el-select no-data-text="no date" v-model="assignTeam.teamIdList" multiple placeholder="Assign Team">
                    <el-option
                            v-for="item in assignTeam.team"
                            :key="item.id"
                            :label="item.user.fullName"
                            :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <el-form-item>
              <el-button @click="assignTeamSubmit('assignTeam')" class="modal__btn" type="primary" plain size="mini">Assign</el-button>
              <!--<button @click="submitForm('assignTeam')">test</button>-->
            </el-form-item>
          </el-form>
        </sweet-modal>
        <!-- [Tree info] end -->

        <!-- document modal -->
        <el-dialog
                :title="(documentList.type)"
                :visible.sync="dialogVisible"
                width="40%"
                :before-close="handleClose">
          <span>You have documents that require action.</span>
          <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
        <el-button type="primary" @click="signDocument">Go</el-button>
      </span>
        </el-dialog>


      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'
  import {AgGridVue} from "ag-grid-vue"
  import InfoTab from '@/components/Projects/InfoTab.vue'
  import taskFilesTabNew from '@/components/Projects/taskFilesTabNew.vue'
  import projProgressTab from '@/components/Projects/projProgressTab.vue'
  import taskCommentsTab from '@/components/Projects/taskCommentsTab.vue'
  import MessagesTask from '@/components/Projects/messages/MessagesTask.vue'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import projectTaskMeetings from '@/components/Projects/projectTaskMeetings.vue'
  import DocumentsTask from '@/components/Projects/DocumentsTask.vue'
  import accountTHINKTab from '@/components/Projects/accountTHINK/accountTHINKTab.vue'

  import empty from "@/assets/img/grid/empty.svg"
  import timer from "@/assets/img/grid/timer.svg"

  import axios from 'axios'

  export default {
    name: 'shared-projects',
    components: {
      // Header,
      AgGridVue,
      projectTaskMeetings,
      DocumentsTask,
      // Menu,
      InfoTab,
      accountTHINKTab,
      taskFilesTabNew,
      projProgressTab,
      taskCommentsTab,
      SweetModal,
      MessagesTask,
    },
    computed:{
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
      user() {
        return this.$store.state.user
      }
    },
    beforeMount() {
      this.gridOptions = {
        suppressCellSelection: true
      };
      this.columnDefs = [
        { headerName: 'Name',
          field: "name",
          width: 70,
          cellRenderer: function(params) {
            return `<span class="txtRender">${params.node.data.name}</span>`
          },
          cellStyle: function(params) {
            if(params.data.status === 'waiting'){
              return {'padding-left':'12px; display: flex; background-color: #C8C8C8;'}
            }
            return {'padding-left':'12px; display: flex;'}
          }
        },
        { headerName: "Company",
          field: "companyName",
          width: 70,
          cellRenderer: function(params) {
            return `<span class="txtRender">${params.node.data.companyName}</span>`
          },
          cellStyle: function(params) {
            if(params.data.status === 'waiting'){
              return {'padding-left':'12px; display: flex; background-color: #C8C8C8;'}
            }
            return {'padding-left':'12px; display: flex;'}
        }
        },
        { headerName: "",
          field: "daysTotal",
          tooltipField: "daysTotal",
          width:12,
          tooltipComponentParams: { fieldName: "Days Total" },
          cellRenderer: function(params) {
            return `<span class="dayRender">${params.node.data.daysTotal}</span>`
          },
          cellStyle: function(params) {
            if(params.data.status === 'waiting'){
              return {'background-color': '#C8C8C8'}
            }
          }
        },
        { headerName: "",
          field: "daysRemaning",
          tooltipField: "daysRemaning",
          tooltipComponentParams: { fieldName: "Days Remaining" },
          // headerClass: 'header-center',
          width:12,
          cellRenderer: function(params) {
            function isEqualTwo(elem){
              return elem === '+'
            }
            const isTooLong = Array.from(params.node.data.daysRemaning.toString()).some(isEqualTwo);
            if(isTooLong){
              return `<div class="dayDoneRemaningRender">${params.node.data.daysRemaning}</div>`
            }else{
              return `<div class="dayRemaningRender">${params.node.data.daysRemaning}</div>`
            }
          },
          cellStyle: function(params) {
            if(params.data.status === 'waiting'){
              return {'background-color': '#C8C8C8'}
            }
          }
        },
        { headerName: '',
          field: "progress",
          cellRenderer: function(params) {
            return `<div class="progress--circle progress--${params.node.data.progress}">
                        <div class="progress__number">${params.node.data.progress}%</div>
                    </div>`
          },
          cellStyle: function(params) {
            if(params.data.status === 'waiting'){
              return {'background-color': '#C8C8C8'}
            }
          },
          tooltipField: "progress",
          tooltipComponentParams: { fieldName: "Progress" },
          width: 12
        },
        {
          headerName: "",
          field: "timerCount",
          cellStyle: function(params) {
            if(params.data.status === 'waiting'){
              return {'background-color': '#C8C8C8'}
            }
          },
          cellRenderer: function(params) {
            if(params.node.data.timerCount){
              return `<img class="timerRender" src=${timer} /></div>`
            }else {
              return `<img class="imageRender" src=${empty} />`
            }
          },
          tooltipField: "timerCount",
          tooltipComponentParams: { fieldName: "Timer" },
          width: 12
        }
      ];
      this.defaultColDef = {
        resizable: true,
        // width: 150,
        sortable: true,
        filter: true
      };
      this.getRowHeight = params => {
        return 40;
      };
      this.rowSelection = "single";
    },
    mounted(){
      this.gridApi = this.gridOptions.api;
      this.gridApi.sizeColumnsToFit();
      this.loadCompanyData(this.$route.query.companyId)
    },
    data() {
      return {
        taskInfo: null,

        companyNameSelect: '',

        activeTab: 'first',
        disabledBtn : true,
        project: '',
        valueProject: '',
        // open: false,

        // table
        gridOptions: null,
        gridApi: null,
        columnApi: null,
        columnDefs: null,
        getRowHeight: null,
        rowData: [],
        defaultColDef: null,
        components: null,
        groupDefaultExpanded: null,
        getDataPath: null,
        getRowNodeId: null,
        autoGroupColumnDef: null,
        rowSelection: null,
        activeAccountTHINKTab: '',

        //infoTab
        isProject: false,
        activeInfoTab: "0",
        activeProjectId: '',
        selectedTaskForInfo: {},
        selectedRows: '',
        selectedRow: {},
        assignTeam:{
          companyId: '',
          companies: [],
          teamIdList: [],
          team:[]
        },
        // documents
        dialogVisible: false,
        documentList: {
          companyId: null,
          projectId: null,
          projectTaskId: null,
          type: ''
        },
        // bookmarks
        // bookmarkList: [],
        rules: {
          // companyId: [
          //   { required: true, message: 'Please select company', trigger: 'change' }
          // ],
          teamIdList: [
            { required: true, message: 'Please select a team', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      async loadCompanyData(companyId) {
        try {
          const projectList = await this.getProjects();

          if (this.$route.query.projectId) {
            const even = (element) => element.id === Number(this.$route.query.projectId);
            const ifProjectInArray = projectList.some(even);

            if(!ifProjectInArray){
              this.notification("Notification", "Project not Found", "info");
              return
            }

            this.valueProject = Number(this.$route.query.projectId);
            const rowData = await this.setProjectRowDataMounted(this.$route.query.projectId);

              if (rowData.length) {
                let task = null;
                task = await this.selectCreatedTask(Number(this.$route.query.taskId) || rowData[0].id);

                // IF NO TASK IN TREE OR IT WAS DELETED
                if (!task) {
                  this.notification("Notification", "Task not Found", "info");
                  await this.selectCreatedTask(rowData[0].id);
                  return
                }
              }

            //Select Active Tab
            switch (this.$route.query.tabName) {
              case 'setShared':
                this.activeTab = 'third';
              break;
              case 'createProjectTaskComment':
                this.activeTab = 'four';
              break;
              case 'createProjectTaskMessage':
                this.activeTab = 'seven';
              break;
              case 'createProjectTaskMeeting':
                this.activeTab = 'eight';
              break;
              // IF EXIST ???
              // case 'createProjectTaskHistory':
              //   alert('createProjectTaskHistory');
              // break;
              case 'reviewProjectTaskDocument':
                // ACTIVE PROJECT TASK Documents
                var activeDocumentTab = this.$route.query.activeDocumentTab;
                this.activeTab = 'fourteen';
                setTimeout(()=>{
                  this.$refs['docs'].selectTab(activeDocumentTab);
                },500);
                break
            }
          }

        } catch (err) {
          console.log(err)
        }
      },
      // submitForm(formName) {
      //   this.$refs[formName].validate((valid) => {
      //     if (valid) {
      //       alert('submit!');
      //     } else {
      //       console.log('error submit!!');
      //       return false;
      //     }
      //   });
      // },
      assignTeamSubmit(form){
        console.log('form', form);
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              sharedCompanyUserIdList: this.assignTeam.teamIdList
            };
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                    .post(`/api/v1/sharedProjectTasks/assignTeam?companyId=${this.$route.query.companyId}&sharedProjectTaskId=${this.selectedRow.sharedTaskId}`, data)
                    .then(response => {
                      if(response.data.success){
                        this.$refs.assignTeamModal.close();
                        this.notification("Success", "Assign Team", "success");
                        this.setProjectRowData(this.activeProjectId);
                        console.log(response);
                        loader.hide()
                      }
                    })
                    .catch(error => {
                      // this.notification("Notification", error.response.data.message, "info")
                      this.$refs.assignTeamModal.close();
                      loader.hide();
                      console.log('An error occurred:', error);
                      loader.hide()
                    });
          }else{
            return false;
          }
        })
      },
      assignTeamOpen(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/sharedProjectTasks/directories?companyId=${this.$route.query.companyId}&projectTaskId=${this.selectedRow.id}&operation=assignTeam`)
                .then(response => {
                // console.log("HAHHSDHASGDAHSGDHASGD", response)
                this.assignTeam.team = response.data.customCompanyUserList.filter(user => user.user.id !== this.user.user.id)
                this.assignTeam.teamIdList = [];
                loader.hide()
                })
                 .catch(error => {
                 console.log('An error occurred:', error);
                 loader.hide()
           });
        this.$refs.assignTeamModal.open();
      },
      handleCommand(command) {
        switch (command) {
          case 'addTaskTimer':
            this.addTaskTimer()
            break;
        }
      },
      getContextMenuItems(params) {
        this.selectCreatedTask(params.node.data.id);
        var _this = this;
        var data = params.node.data;
        var contextMenuItemList = [];
            contextMenuItemList.push({
              name: 'Assign Team',
              action: function () {
                console.log("THIS", this);
                _this.assignTeamOpen()
              },
              icon: '<i class="el-icon-plus"></i>',
            });
        if(data.type === 'task' && this.selectedRow.taskStatus === 2 || data.type === 'task' && this.selectedRow.taskStatus === 5){
          contextMenuItemList.push({
            name: 'Add task timer',
            action: function () {
              _this.handleCommand('addTaskTimer');
              // console.log("Delete")
            },
            icon: '<i class="el-icon-time"></i>',
          });
        }
        return contextMenuItemList;
      },
      addTaskTimer(){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskTimers/create?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.selectedRow.id}`)
                .then(response => {
                  console.log('---projectTaskTimers/create', response.data);
                  this.$store.dispatch('getTimerList', {projectId: this.$route.query.projectId, projectTaskId: this.selectedRow.id})
                  this.notification("Success", "Task start time", "success");
                  this.setProjectRowData(this.$route.query.projectId, Number(this.$route.query.taskId) || 0);
                  this.activeTab = 'third'
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
      },
      // openDialog(){
      //   this.$emit('openChat2')
      // },
      // selectCompany(id){
      //   let loader = this.$loading.show();
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //           .post(`/api/v1/sharedProjectTasks/directories?companyId=${this.$route.query.companyId}&operation=getCustomCompanyUserList&customCompanyId=${id}`)
      //           .then(response => {
      //             // console.log("HAHHSDHASGDAHSGDHASGD", response)
      //             this.assignTeam.team = response.data.customCompanyUserList
      //             this.assignTeam.teamIdList = []
      //             loader.hide()
      //           })
      //           .catch(error => {
      //             console.log('An error occurred:', error);
      //             loader.hide()
      //             loader.hide()
      //           })
      // },
      getProjects(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/sharedProjectTasks/getProjectList?companyId=${this.$route.query.companyId}`)
                  .then(response => {
                    if(response.data.projectList.length === 0){
                      this.valueProject = "";
                      this.project = [];
                    }else{
                      this.project = response.data.projectList
                    }
                    loader.hide();
                    resolve(this.project)
                  })
                  .catch(error => {
                    loader.hide();
                    reject(error)
                  })
        })
      },
      setProjectRowData(projectId, state){
        let loader = this.$loading.show();
        console.log("selected ID", projectId);
        this.activeProjectId = projectId;
        this.$router.push(`/shared-projects?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}`);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/sharedProjectTasks/list?companyId=${this.$route.query.companyId}&projectId=${projectId}`)
                .then(response => {
                  console.log("SHARED TASKS", response.data.list);
                  let result = [];
                  // for (let i = 0; i < response.data.list.length; i++){
                  //   result.push(response.data.list[i].projectTask)
                  //   this.rowData = result
                  // }
                  this.rowData = this.buildTree(response.data.list);
                  if(state === 'first'){
                    setTimeout(() => {
                      this.selectCreatedTask(this.rowData[0].id)
                    }, 100)
                  }else{
                    setTimeout(() => {
                    this.selectCreatedTask(this.selectedRow.id)
                    }, 100)
                  }
                  // if (response.data.list.length) {
                  //   this.getProjectLayout(this.$route.query.companyId, projectId);
                  // }
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                })
      },
      setProjectRowDataMounted(projectId){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          this.activeProjectId = projectId;
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/sharedProjectTasks/list?companyId=${this.$route.query.companyId}&projectId=${projectId}`)
                  .then(response => {
                    this.rowData = this.buildTree(response.data.list);
                    loader.hide();
                    // if (response.data.list.length) {
                    //   this.getProjectLayout(this.$route.query.companyId, projectId);
                    // }
                    resolve(this.rowData)
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide();
                    reject(error)
                  })
        });
      },
      selectCreatedTask(id) {
        return new Promise ((resolve) => {
          this.gridApi.forEachNode(function (node) {
            if (node.data.id === id) {
              node.setSelected(true);
              resolve(node.data)
            }
          });
          resolve(null)
        })
      },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   this.companyNameSelect = name
      // },
      onSelectionChanged(){
        this.disabledBtn = false;
          if(this.activeInfoTab === "0"){
              this.activeInfoTab = 'first'
          }
        this.selectedRows = this.gridApi.getSelectedRows();
        this.selectedRow = this.selectedRows[0];
        console.log('SELECTED ROWS', this.selectedRows);
        console.log('SELECTED ROW', this.selectedRow);

        if(this.selectedRow.status === 'waiting') {
          return this.alertIfNotSharing()
        }

        let data = {'taskId': this.selectedRow.id, 'projectId': this.activeProjectId};
        this.$router.push(`/shared-projects?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&taskId=${this.selectedRow.id}`);
        // CHECK IF USER IN SHARED TEM SO DOWNLOAD DOCUMENTS
        if (this.selectedRow.sharedStatus === 'sharedTeam') {
          this.getTaskLayout(this.$route.query.companyId, this.selectedRow.projectId, this.selectedRow.id);
        }
        switch (this.activeTab) {
            case 'first':
              switch (this.activeInfoTab) {
                case 'first':
                  this.getTaskInfo(this.selectedRow.id);
                  break;
                case 'second':
                  this.$store.dispatch('getTaskTeamGridData', this.selectedRow.id);
                  break;
                case 'third':
                  this.$store.dispatch('getTaskClientsGridData', this.selectedRow.id);
                  break;
                case 'four':
                  this.$store.dispatch('getTaskVendorsGridData', this.selectedRow.id)
              }
              break;
            case 'second':
              this.$store.dispatch('getTaskFiles', this.selectedRow.id);
              break;
            case 'third':
              this.$store.dispatch('getProgressesList', data);
              this.$store.dispatch('getTimerList', {projectId: this.activeProjectId, projectTaskId: this.selectedRow.id});
              break;
            case 'four':
              this.$store.dispatch('getProjectTaskComments', data);
              break;
          case 'seven':
            this.$store.dispatch('getMessagesDirectories', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id});
            this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'});
            break;
          case 'fourteen':
            this.$store.dispatch('getDocuments', this.selectedRow.id);
            break;
            default:
          }
      },
      getProjectLayout(companyId, projectId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projectLayout/getData?companyId=${companyId}&projectId=${projectId}`)
                  .then(response => {
                    if (response.data.document) {
                      this.documentList.companyId = response.data.document.companyId;
                      this.documentList.projectId = response.data.document.projectId;
                      this.documentList.projectTaskId = response.data.document.projectTaskId;
                      if (response.data.document.type == 'riskassesment') {
                        this.documentList.type = 'commercial'
                      } else if (response.data.document.type == 'envirenmental') {
                        this.documentList.type = 'general'
                      } else {
                        this.documentList.type = response.data.document.type
                      }
                      this.dialogVisible = true
                    }
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      getTaskLayout(companyId, projectId, taskId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projectTaskLayout/getData?companyId=${companyId}&projectId=${projectId}&projectTaskId=${taskId}`)
                  .then(response => {
                    // this.bookmarkList = response.data.data.bookmarks;
                    if (response.data.document) {
                      this.documentList.companyId = response.data.document.companyId
                      this.documentList.projectId = response.data.document.projectId
                      this.documentList.projectTaskId = response.data.document.projectTaskId
                      if (response.data.document.type == 'riskassesment') {
                        this.documentList.type = 'commercial'
                      } else if (response.data.document.type == 'envirenmental') {
                        this.documentList.type = 'general'
                      } else {
                        this.documentList.type = response.data.document.type
                      }
                      this.dialogVisible = true
                    }
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      alertIfNotSharing(){
        this.$confirm('Request to accept shared with you task.', 'Warning', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Accept',
          cancelButtonText: 'Reject',
          type: 'info'
        }).then(async () => {
          try{
            await this.acceptSharing(this.selectedRow);

            await this.deleteNotification(this.selectedRow.notificationId);

            await this.setSharedTask();
          }catch (err){
            console.log(err)
          }
        }).catch(async (action) => {
          try {
            if(action === 'cancel'){
              await this.rejectSharing(this.selectedRow);

              await this.deleteNotification(this.selectedRow.notificationId);

              await this.setSharedTask();

              await this.selectCreatedTask(this.rowData[0].id)
            }else{
              await this.selectCreatedTask(this.rowData[0].id)
            }
          }catch (err){
            console.log(err)
          }
        });
      },
      acceptSharing(data){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/sharedProjectTasks/accept?companyId=${data.invitedCompanyId}&tempSharedProjectTaskId=${data.tempSharedProjectTaskId}`)
                  .then(response => {
                    console.log(response);
                    loader.hide();
                    resolve('ok')
                  })
                  .catch(error => {
                    console.log('An error occurred:', error.response.data.message);
                    loader.hide();
                    reject(error)
                  })
        });
      },
      rejectSharing(data){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/sharedProjectTasks/reject?companyId=${data.invitedCompanyId}&tempSharedProjectTaskId=${data.tempSharedProjectTaskId}`)
                  .then(response => {
                    console.log(response);
                    loader.hide();
                    resolve('ok')
                  })
                  .catch(error => {
                    console.log('An error occurred:', error.response.data.message);
                    loader.hide();
                    reject(error)
                  })
        });
      },
      deleteNotification(id){
        return new Promise ((resolve, reject) => {
                  let loader = this.$loading.show();
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.post(`/api/v1/notifications/delete?notificationId=${id}`)
                          .then(response => {
                            loader.hide();
                            resolve('ok')
                          }).catch(error => {
                            loader.hide();
                            reject(error)
                  })
        })
      },
      refreshBlock(){
        this.rowData = [];
        this.disabledBtn = true
        this.valueProject = ''
        this.getProjects()
      },
      onGridReady(params) {},
      handleClick(tab, event) {
        let data = {'taskId': this.selectedRow.id, 'projectId': this.activeProjectId}
        console.log("THIS ACTIVE TAB", tab);
        console.log(tab, event);
        if(tab.name === 'first'){
            this.getTaskInfo(this.selectedRow.id)
        }
        else if(tab.name === 'second'){
          this.$store.dispatch('getTaskFiles', this.selectedRow.id)
        }else if(tab.name === 'third'){
          this.$store.dispatch('getProgressesList', data)
          this.$store.dispatch('getTimerList', {projectId: this.activeProjectId, projectTaskId: this.selectedRow.id});
        }else if(tab.name === 'four'){
          this.$store.dispatch('getProjectTaskComments', data)
        }else if(tab.name === 'seven'){
          this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
          this.$store.dispatch('getMessagesDirectories', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id})
        }else if(tab.name === 'fourteen'){
          this.$store.dispatch('getDocuments', this.selectedRow.id)
        }
      },
      getTaskInfo(id) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTasks/info?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${id}`)
                .then(response => {
                  this.selectedTaskForInfo = response.data.info
                  this.isProject = false
                  // switch (this.activeInfoTab) {
                  //   engagement 'first':
                  //     console.log("TASK DETAIL")
                  //     break;
                  //   engagement 'second':
                  //     console.log("TASK TEAM")
                  //     this.$store.dispatch('getTaskTeamGridData', this.selectedRow.id)
                  //     break;
                  //   engagement 'third':
                  //     this.$store.dispatch('getTaskClientsGridData', this.selectedRow.id)
                  //     break;
                  //   engagement 'four':
                  //     this.$store.dispatch('getTaskVendorsGridData', this.selectedRow.id)
                  //     break;
                  //   default:
                  // }
                  console.log('SELECTED TASK ROW INFO', this.selectedTaskForInfo);
                  if (response.data.info.startDate.toString().length < 8) {
                    this.selectedTaskForInfo.startDate = '0' + response.data.info.startDate.toString()
                    this.selectedTaskForInfo.startDate = moment(response.data.info.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  } else {
                    this.selectedTaskForInfo.startDate = moment(response.data.info.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  }
                  if (response.data.info.deadlineDate.toString().length < 8) {
                    this.selectedTaskForInfo.deadlineDate = '0' + response.data.info.deadlineDate.toString()
                    this.selectedTaskForInfo.deadlineDate = moment(response.data.info.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  } else {
                    this.selectedTaskForInfo.deadlineDate = moment(response.data.info.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  }
                  // console.log("START DATE1!!!!", this.selectedTaskForInfo.deadlineDate)
                  // console.log("START DATE2!!!!", start)
                })
                .catch(error => {
                  // if (error.response.data.statusCode == 401) {
                  //   localStorage.clear();
                  //   this.$router.push('/login')
                  // }
                  console.log('An error occurred:', error);
                });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTasks/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}`)
          .then(response => {
            console.log('---UUUUUU', response.data.extendedInfo);
            response.data.extendedInfo.projectCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.projectTaskCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.projectTaskCompanyClientList.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.projectTaskCompanyClientPersonList.sort(function (a, b) {
              if (a.companyVendorPerson.fullName.toLowerCase() > b.companyVendorPerson.fullName.toLowerCase()) {
                return 1;
              }
              if (a.companyVendorPerson.fullName.toLowerCase() < b.companyVendorPerson.fullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.projectTaskCompanyVendorList.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.projectTaskCompanyVendorPersonList.sort(function (a, b) {
              if (a.companyVendorPerson.fullName.toLowerCase() > b.companyVendorPerson.fullName.toLowerCase()) {
                return 1;
              }
              if (a.companyVendorPerson.fullName.toLowerCase() < b.companyVendorPerson.fullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            this.taskInfo = response.data.extendedInfo
            loader.hide()
          })
          .catch(error => {
            // if (error.response.data.statusCode == 401) {
            //   localStorage.clear();
            //   this.$router.push('/login')
            // }
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      refreshTreeAfterDeleteTimer(projectId){
        if(this.valueProject === projectId){
          this.setProjectRowData(Number(this.$route.query.projectId), Number(this.$route.query.taskId) || 0);
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      assignTeamClose(){
        this.assignTeam.companyId = ''
        this.assignTeam.companies = []
        this.assignTeam.team = []
        this.assignTeam.teamIdList = []
        this.$refs['assignTeam'].resetFields();
      },
      setSharedTask(){
        this.getProjects();
        this.$store.dispatch('getCompanyLayout');
        if(this.valueProject){
          this.setProjectRowData(this.valueProject)
        }
      },
      // document
      handleClose(done) {
        this.dialogVisible = false
      },
      signDocument() {
        this.dialogVisible = false;
        if (this.$route.query.taskId == this.documentList.projectTaskId) {
          this.activeTab = 'fourteen';
          this.$refs['docs'].selectTab(this.documentList.type);
          this.$store.dispatch('getDocuments', this.documentList.projectTaskId)
        } else {
          this.$router.push({query: {companyId: this.$route.query.companyId, projectId: this.documentList.projectId, taskId: this.documentList.projectTaskId, tabName: 'reviewProjectTaskDocument'}}).then(data => {
            this.$emit('rerenderMainLayout')
          })
        }
      },
      buildTree(projectTaskList) {
        var resultProjectTaskTree = [];
        var todaysdate = moment();
        for (let i = 0; i < projectTaskList.length; i++ ){
          var startTask = '';
          var endTask = '';
          if (projectTaskList[i].projectTask.startDate.toString().length < 8) {
            startTask = '0' + projectTaskList[i].projectTask.startDate.toString()
          } else {
            startTask = projectTaskList[i].projectTask.startDate.toString()
          }
          if (projectTaskList[i].projectTask.deadlineDate.toString().length < 8) {
            endTask = '0' + projectTaskList[i].projectTask.deadlineDate.toString()
          } else {
            endTask = projectTaskList[i].projectTask.deadlineDate.toString()
          }
          startTask = moment(startTask, 'DDMMYYYY');
          endTask = moment(endTask, 'DDMMYYYY');
          let myDaysTotal = moment.duration(endTask.diff(startTask)).asDays();

          var tillTaskEnd = moment.duration(endTask.diff(todaysdate)).asDays();

          if(projectTaskList[i].projectTask.status === 4){
            var dateString = moment.unix(projectTaskList[i].projectTask.endedDate).format("DDMMYYYY");

            dateString = moment(dateString, 'DDMMYYYY');
            tillTaskEnd = moment.duration(endTask.diff(dateString)).asDays();
            tillTaskEnd = '(' + tillTaskEnd + ')'
          }else{
            tillTaskEnd = Math.ceil(tillTaskEnd)
          }
          // CHECK IF USER IN SHARED TEAM OR JUST SHARED
          let sharedStatus = 'shared';
          const even = (element) => element === this.companyLayout.companyUserId;
          const ifUserInTeam = projectTaskList[i].userList.some(even);
          if (ifUserInTeam) {
            sharedStatus = 'sharedTeam';
          }
          resultProjectTaskTree.push({
            id: projectTaskList[i].projectTask.id,
            name: projectTaskList[i].projectTask.name,
            daysTotal: Math.floor(myDaysTotal),
            daysRemaning: tillTaskEnd,
            companyName: projectTaskList[i].company.name,
            projectId: projectTaskList[i].projectId,
            sharedTaskId:projectTaskList[i].id,
            sharedStatus: sharedStatus,
            timerCount: projectTaskList[i].projectTask.timerCount,
            userList: projectTaskList[i].userList,
            invitedCompanyId: projectTaskList[i].companyId,
            notificationId: projectTaskList[i].notif ? projectTaskList[i].notif.id : null,
            tempSharedProjectTaskId: projectTaskList[i].notif ? projectTaskList[i].notif.params._tempSharedProjectTaskId : null,
            status: projectTaskList[i].status,
            progress: Math.floor(projectTaskList[i].projectTask.progress),
            type: 'task',
            taskStatus: projectTaskList[i].projectTask.status
          });
        }
        return resultProjectTaskTree;
      }
    },
    watch:{
      rowData(val){
        if(val.length === 0){
          this.disabledBtn = true
        }else{
          this.disabledBtn = false
        }
        //TODO selectedRows after create
        setTimeout(() => {
          if (this.selectedRow.id) {
            this.selectCreatedTask(this.selectedRow.id)
          }
        }, 100)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .shared-projects {
    background: #DfE8F0;
    height: 100vh;
  }

  .content {
    display: flex;
    height: 100vh;
    padding-top: 50px;
  }

  // [ Wrapper ] start
  .wrap {
    display: flex;
    width: 100%;
    height: 95%;
    padding: 20px 10px 0 10px;
    .left-side{
      width: 825px;
      padding: 0 10px 10px 0;
    }
    &__tree {
      width: 825px;
      padding: 0 10px 10px 0;
    }
    &__info {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 65%;
      padding: 50px 0 10px 10px;
    }
    &__info-tab {
      height: 50%;
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          margin-bottom: 8px;
          span {
            font-weight: 500;
            color: #909399;
          }
        }
      }
    }
    &__person {
      height: 50%;
    }
  }
  .el-tabs{
    height:100vh;
  }
  // [ Wrapper ] end
  .flex{
    display:flex;
  }
  .two-columns > div{
    max-width:45%;
    width:100%;
  }
</style>

<style lang="less" scoped>
  .nav-tree{
    padding: 0px 0 20px 0;
    .el-select {
      margin-right: 10px;
    }
  }
</style>
